import NAME from "./constants";

export const getGalleryIsLoading = store => store[NAME].loading;
export const getGalleryImages = store => store[NAME].images;
